import { render, staticRenderFns } from "./DnaSearch.vue?vue&type=template&id=5f5b2f0a&scoped=true"
import script from "./DnaSearch.vue?vue&type=script&lang=js"
export * from "./DnaSearch.vue?vue&type=script&lang=js"
import style0 from "./DnaSearch.vue?vue&type=style&index=0&id=5f5b2f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b2f0a",
  null
  
)

export default component.exports